
import * as types from "../config/types";

const initialState = {
  loading: false,
  detailRecord: [],
  parse:null,
  resultStatus:false,
  error: null
};

export default function detailRecord (state = initialState, action)  {
  switch (action.type) {
    case types.GET_DETAIL_RECORD_REQUEST: {
      return {
        ...state,
        loading: true,   
        resultStatus:false,
        error: null,
      };
    }
    case types.GET_DETAIL_RECORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        resultStatus:true,
        detailRecord: action.payload.detailRecord.rows
      };
    }
    case types.GET_DETAIL_RECORD_FAILED: {
      return {
        ...state,
        loading: false,
        error: "FAILED",      
        resultStatus:false,  
      };
    }
    default:
      return state;
  }
};

